module.exports = __webpack_public_path__ + "static/media/avatar.bc560060.png";